import { Typography } from 'antd';
import { BarChartOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

/** 报表统计页面（占位，后续需求实现） */
export default function ReportsPage() {
  return (
    <div>
      <Title level={3}>
        <BarChartOutlined /> 报表统计
      </Title>
      <Text type="secondary">报表统计与 CSV 导出功能将在后续需求中实现。</Text>
    </div>
  );
}
